(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "polished"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("polished"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.polished);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _polished) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.yellow = _exports.white = _exports.twitterBlue = _exports.turquoiseGreen = _exports.teal = _exports.tangerine = _exports.red = _exports.officeRed = _exports.newport = _exports.moonlight = _exports.midnight = _exports.mediumGrey = _exports.mediumBlueGrey = _exports.linkedInBlue = _exports.lightYellow = _exports.lightRed = _exports.lightGrey = _exports.lightGreen = _exports.lightBlueGrey = _exports.lightBlue = _exports.husky = _exports.green = _exports.grappa = _exports.googleBlue = _exports.facebookBlue = _exports.evenLighterGrey = _exports.dune = _exports.darkYellow = _exports.darkTeal = _exports.darkRed = _exports.darkNewport = _exports.darkGrey = _exports.darkGreen = _exports.darkBlue = _exports.clay = _exports.brightRed = _exports.blueGrey = _exports.blue = _exports.black = _exports.avalanche = _exports.aquaGreen = _exports.aaDarkGrey = void 0;

  /*
   |------------------------------------------------------------------------------
   | Primary
   |------------------------------------------------------------------------------
   */

  var newport = "#48646b";
  _exports.newport = newport;
  var darkNewport = (0, _polished.darken)(0.15, newport);
  _exports.darkNewport = darkNewport;
  var teal = "#93ccc0";
  _exports.teal = teal;
  var darkTeal = (0, _polished.darken)(0.15, teal);

  /*
   |------------------------------------------------------------------------------
   | Secondary
   |------------------------------------------------------------------------------
   */
  _exports.darkTeal = darkTeal;
  var tangerine = "#e7573c";
  _exports.tangerine = tangerine;
  var avalanche = "#ffffff";
  _exports.avalanche = avalanche;
  var moonlight = "#f7f7f5";
  _exports.moonlight = moonlight;
  var dune = "#f0efd7";
  _exports.dune = dune;
  var grappa = "#574a54";
  _exports.grappa = grappa;
  var husky = "#cbd6d6";

  /*
   |------------------------------------------------------------------------------
   | Neutrals
   |------------------------------------------------------------------------------
   */
  _exports.husky = husky;
  var white = "#ffffff";
  _exports.white = white;
  var black = "#000000";
  _exports.black = black;
  var clay = "#cccccc";
  _exports.clay = clay;
  var midnight = "#000000";
  _exports.midnight = midnight;
  var blueGrey = "#141414";
  _exports.blueGrey = blueGrey;
  var mediumBlueGrey = "#7C8698";
  _exports.mediumBlueGrey = mediumBlueGrey;
  var lightBlueGrey = "#EFF0F3";
  // Was "#6e6e6e" but didn't provide enough contrast
  _exports.lightBlueGrey = lightBlueGrey;
  var aaDarkGrey = "#a0a0a0";
  _exports.aaDarkGrey = aaDarkGrey;
  var darkGrey = "#6e6e6e";
  _exports.darkGrey = darkGrey;
  var mediumGrey = "#bababb";
  _exports.mediumGrey = mediumGrey;
  var lightGrey = "#e7e7e7";
  _exports.lightGrey = lightGrey;
  var evenLighterGrey = "#bababa";

  /*
   |------------------------------------------------------------------------------
   | Helpers
   |------------------------------------------------------------------------------
   */
  _exports.evenLighterGrey = evenLighterGrey;
  var blue = "#2bb3ee";
  _exports.blue = blue;
  var darkBlue = (0, _polished.darken)(0.15, blue);
  _exports.darkBlue = darkBlue;
  var lightBlue = (0, _polished.lighten)(0.15, blue);
  _exports.lightBlue = lightBlue;
  var green = "#1B835D";
  _exports.green = green;
  var darkGreen = (0, _polished.darken)(0.15, green);
  _exports.darkGreen = darkGreen;
  var lightGreen = (0, _polished.lighten)(0.15, green);
  _exports.lightGreen = lightGreen;
  var aquaGreen = "#9fd6c4";
  _exports.aquaGreen = aquaGreen;
  var turquoiseGreen = "#17C289";
  _exports.turquoiseGreen = turquoiseGreen;
  var red = "#ff7977";
  _exports.red = red;
  var darkRed = (0, _polished.darken)(0.15, red);
  _exports.darkRed = darkRed;
  var lightRed = (0, _polished.lighten)(0.15, red);
  _exports.lightRed = lightRed;
  var brightRed = "#eA4335";
  _exports.brightRed = brightRed;
  var yellow = "#f9b131";
  _exports.yellow = yellow;
  var darkYellow = (0, _polished.darken)(0.15, yellow);
  _exports.darkYellow = darkYellow;
  var lightYellow = (0, _polished.lighten)(0.15, yellow);

  /*
   |------------------------------------------------------------------------------
   | Third Party
   |------------------------------------------------------------------------------
   */
  _exports.lightYellow = lightYellow;
  var facebookBlue = "#3b5998";
  _exports.facebookBlue = facebookBlue;
  var twitterBlue = "#1da1f2";
  _exports.twitterBlue = twitterBlue;
  var linkedInBlue = "#0077b5";
  _exports.linkedInBlue = linkedInBlue;
  var googleBlue = "#4285f4";
  _exports.googleBlue = googleBlue;
  var officeRed = "#c93e2b";
  _exports.officeRed = officeRed;
});